import classNames from 'classnames';

import { XIcon } from '@icons';
import { setupForDark } from '@theme';

const CloseButton = ({
  onClick,
  className = '',
  'data-testid': dataTestId
}: {
  onClick: () => void;
  className?: string;
  'data-testid'?: string;
}) => {
  return (
    <div
      onClick={onClick}
      data-testid={dataTestId}
      className={classNames(
        'flex flex-col items-center justify-center',
        'rounded-full',
        'cursor-pointer',
        'w-xl h-xl',
        setupForDark('bg-button1-disabled text-icon-tertiary'),
        className
      )}
    >
      <XIcon size={19} />
    </div>
  );
};

export default CloseButton;
